module.exports = __webpack_public_path__ + "static/presenting-1-a6e9dd87dd177ed909c1d26d64010be3.jpg";